'use client'

import { trackEvent, getOneTrustAllowedCategoriesClient } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { setCookie } from '@patrianna/shared-utils/cookie'

import BannerTile from 'components/BannerTile'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'

type Props = {
  // own props
  cookie: 'IS_USER_VISITED_INSTAGRAM' | 'IS_USER_VISITED_FB' | 'IS_USER_VISITED_X'
  imgKey: 'instagram' | 'facebook' | 'x'
  link: string
}

export default function SocialBanner(props: Props) {
  const { cookie, link, imgKey } = props
  const bannerUrl = generateImageUrl(`banners/${imgKey}.png`, ImagesDirectory.BANNERS)
  const isFunctionalAllowed = getOneTrustAllowedCategoriesClient().includes('C0003')

  const onBannerClick = () => {
    nextTick().then(() => {
      trackEvent('clicked_on_banner', { category: `${imgKey}-banner` })

      if (cookie && isFunctionalAllowed) {
        setCookie(cookie, '1')
      }
    })
  }

  return (
    <BannerTile
      url={link}
      openInNewTab
      onClick={onBannerClick}
      dataTest={`${imgKey}-banner`}
      src={bannerUrl}
      alt={`visit ${imgKey}`}
    />
  )
}
